import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  ticketInfo: {
    color: theme.palette.neutral400,

    "& .MuiTypography-root.MuiCardHeader-subheader": {
      color: theme.palette.neutral400,
    },
    [theme.breakpoints.down("xs")]: {
      flex: "1 1 auto",
      minWidth: 0,
      padding: "8px 4px 8px 0",
      "& .MuiCardHeader-content": {
        minWidth: 0,
        flex: "1 1 auto",
      },
      "& .MuiCardHeader-avatar": {
        marginRight: 8,
        flex: "0 0 auto",
      },
      "& .MuiCardHeader-action": {
        margin: 0,
      },
    },
  },
}))

export default useStyles
